import { Component, OnInit, Input } from '@angular/core';
import { LFDynamicWidgetConfig } from '../../../models/lf-dynamic-widget-config';
import { FormPageConfig } from '../../../models/form-page-config';
import { DetailedEntityDataService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-data.service';
import { DetailedEntityButtonService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-button.service';
import { SearchService } from '../../../search/search.service';

@Component({
  selector: 'lfwms-simple-widget-layout',
  templateUrl: './simple-widget-layout.component.html',
  styleUrls: ['./simple-widget-layout.component.css']
})
export class SimpleWidgetLayoutComponent implements OnInit {

  @Input() public pageConfig: FormPageConfig;
  @Input() public widgetList: Array<LFDynamicWidgetConfig>;

  public primaryWidgetList: Array<LFDynamicWidgetConfig> = [];
  public detailWidget: LFDynamicWidgetConfig;
  public dataService: DetailedEntityDataService;
  public buttonService: DetailedEntityButtonService;
  public detailsSearchService: SearchService;

  constructor() { }

  public ngOnInit() {
    this.dataService = <DetailedEntityDataService>this.pageConfig.dataService;
    this.detailsSearchService = this.dataService.detailsSearchService;
    this.buttonService = <DetailedEntityButtonService>this.pageConfig.buttonService;
    this.initializeWidgets();
  }

  // split the widgets into primary and detail widgets
  private initializeWidgets() {
    this.widgetList.forEach(widget => {
      widget.isOpen = true;
      if (widget.id === 'Details') {
        this.detailWidget = widget;
      } else {
        this.primaryWidgetList.push(widget);
      }
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/layout/simple-widget-layout/simple-widget-layout.component.ts